import { createAnimatedLottie } from '../Lottie';

export const AnimatedTranslationIcon = createAnimatedLottie({
    dark: () => import('./assets/icon-dark.json'),
    light: () => import('./assets/icon-light.json'),
});
